import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HelpService {
  private httpClient = inject(HttpClient);

  private readonly baseUrl = 'api/1.0/help';

  /** Loads a Markdown page, e.g. `anwender/index.md`. */
  getPage = (path: string): Observable<string> => {
    return this.httpClient.get(this.url(path), { responseType: 'text' });
  };

  /** Loads a downloadable file, e.g. `anwender/files/2601 Handbuch Methode tacs®.pdf`. */
  getFile = (path: string): Observable<Blob> => {
    return this.httpClient.get(this.url(path), { responseType: 'blob' });
  };

  private url = (path: string): string => {
    return `${this.baseUrl}/${path.split('/').map(encodeURIComponent).join('/')}`;
  };
}
